export default __webpack_public_path__ + "dd538dc40d2917b6f4f75a06af705642.svg";